import type { Color, CommonColors } from '@mui/material/styles'

export const blueTechVariants: Color = {
  '900': '#003d3c',
  '800': '#007573',
  '700': '#008f8c',
  '600': '#00b7b5',
  '500': '#00e0dd',
  '400': '#0afffb',
  '300': '#70fffd',
  '200': '#d3eeee',
  '100': '#d6fffe',
  '50': '#ebffff',
  // Computed value, not provided by the figma
  A100: '#aaffff',
  A200: '#55ffff',
  A400: '#00ffff',
  A700: '#00c9c6'
}
export const blueDeepVariants: Color = {
  '900': '#02173c',
  '800': '#042e77',
  '700': '#05368a',
  '600': '#053d9e',
  '500': '#064cc6',
  '400': '#075ced',
  '300': '#2573f8',
  '200': '#6199fa',
  '100': '#b0ccfd',
  '50': '#ebf2fe',
  // Computed value, not provided by the figma
  A100: '#add6ff',
  A200: '#66b2ff',
  A400: '#2979ff',
  A700: '#004bb5'
}

export const violetVariants: Color = {
  '900': '#1a2137',
  '800': '#273153',
  '700': '#34436f',
  '600': '#41548b',
  '500': '#4e64a6',
  '400': '#6478b6',
  '300': '#909fcb',
  '200': '#bac3de',
  '100': '#e3e7f2',
  '50': '#f1f3f9',
  // Computed value, not provided by the figma
  A100: '#d0d9ff',
  A200: '#a0b8ff',
  A400: '#587fff',
  A700: '#3a56cc'
}

export const limeGreenVariants: Color = {
  '900': '#1a460c',
  '800': '#2e7915',
  '700': '#3c9c1c',
  '600': '#50d025',
  '500': '#5ada2f',
  '400': '#83e363',
  '300': '#97e87d',
  '200': '#c8f3ba',
  '100': '#e3f9dc',
  '50': '#f1fcee',
  // Computed value, not provided by the figma
  A100: '#c4f7a3',
  A200: '#8ef159',
  A400: '#54e82a',
  A700: '#3ecc19'
}

export const yellowVariants: Color = {
  '900': '#664e00',
  '800': '#b98f04',
  '700': '#cc9c00',
  '600': '#f5bc00',
  '500': '#ffcb1f',
  '400': '#ffd447',
  '300': '#ffe085',
  '200': '#ffecb3',
  '100': '#fff8e1',
  '50': '#fffcf2',
  // Computed value, not provided by the figma
  A100: '#fff3b0',
  A200: '#ffe066',
  A400: '#ffd500',
  A700: '#ccaa00'
}

export const redVariants: Color = {
  '900': '#b71c1c',
  '800': '#c62828',
  '700': '#d32f2f',
  '600': '#e53935',
  '500': '#f44336',
  '400': '#ef5350',
  '300': '#e57373',
  '200': '#ef9a9a',
  '100': '#ffebee',
  '50': '#fff6f7',
  // Computed value, not provided by the figma
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
}

export const blackVariants: Color = {
  '900': '#212121',
  '800': '#424242',
  '700': '#616161',
  '600': '#757575',
  '500': '#8c8c8c',
  '400': '#bdbdbd',
  '300': '#e8e8e8',
  '200': '#eeeeee',
  '100': '#f5f5f5',
  '50': '#fafafa',
  // Computed value, not provided by the figma
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#7f7f7f',
  A700: '#5c5c5c'
}

export const commonColors: CommonColors = {
  black: '#000000',
  white: '#ffffff'
}
